// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-card {
  margin: 30px;
  padding: 30px;
  width: -moz-fit-content;
  width: fit-content;
  height: -moz-fit-content;
  height: fit-content;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.1254901961);
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  max-width: 360px;
}

.login-form-input {
  background-color: whitesmoke !important;
  border-bottom-color: rgba(0, 0, 0, 0.38) !important;
  color: rgba(0, 0, 0, 0.87) !important;
}

.d-row {
  display: flex;
  flex-direction: row;
}

.d-col {
  display: flex;
  flex-direction: column;
}

.justify-content-center {
  justify-content: center;
}

.justify-content-end {
  justify-content: flex-end;
}

.m-b-20 {
  margin-bottom: 20px;
}

.m-b-10 {
  margin-bottom: 10px;
}

.m-0 {
  margin: 0px;
}

.align-items-center {
  align-items: center;
}
.align-items-center img {
  background-color: #206ead;
  padding: 1em;
  width: 80%;
}

.login-header {
  font-size: 20px;
  font-weight: bold;
}

.checkbox-label {
  display: inline-flex;
}

.checkbox-square {
  aspect-ratio: 1;
}

.m-r-5 {
  margin: 0px 5px 0px 0px !important;
}

.login-button {
  width: 100%;
  text-transform: capitalize;
}

.cursor-pointer {
  cursor: pointer;
}

.loading-screen {
  min-height: 280px;
  font-size: 60px;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/account/components/login/login.component.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,aAAA;EACA,uBAAA;EAAA,kBAAA;EACA,wBAAA;EAAA,mBAAA;EACA,iDAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AACJ;;AAEA;EACI,uCAAA;EACA,mDAAA;EACA,qCAAA;AACJ;;AAEA;EACI,aAAA;EACA,mBAAA;AACJ;;AAEA;EACI,aAAA;EACA,sBAAA;AACJ;;AAEA;EACI,uBAAA;AACJ;;AAEA;EACI,yBAAA;AACJ;;AAEA;EACI,mBAAA;AACJ;;AACA;EACI,mBAAA;AAEJ;;AAAA;EACI,WAAA;AAGJ;;AAAA;EACI,mBAAA;AAGJ;AADI;EACI,yBAAA;EACA,YAAA;EACA,UAAA;AAGR;;AACA;EACI,eAAA;EACA,iBAAA;AAEJ;;AACA;EACI,oBAAA;AAEJ;;AAAA;EACI,eAAA;AAGJ;;AADA;EACI,kCAAA;AAIJ;;AAFA;EACI,WAAA;EACA,0BAAA;AAKJ;;AAFA;EACI,eAAA;AAKJ;;AAFA;EACI,iBAAA;EACA,eAAA;AAKJ","sourcesContent":[".login-card {\n    margin: 30px;\n    padding: 30px;\n    width: fit-content;\n    height: fit-content;\n    box-shadow: 0 3px 6px #00000020;\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    max-width: 360px;\n}\n\n.login-form-input {\n    background-color: whitesmoke !important;\n    border-bottom-color: rgba(0, 0, 0, 0.38) !important;\n    color: rgba(0, 0, 0, 0.87) !important;\n}\n\n.d-row {\n    display: flex;\n    flex-direction: row;\n}\n\n.d-col {\n    display: flex;\n    flex-direction: column;\n}\n\n.justify-content-center {\n    justify-content: center;\n}\n\n.justify-content-end {\n    justify-content: flex-end;\n}\n\n.m-b-20 {\n    margin-bottom: 20px;\n}\n.m-b-10 {\n    margin-bottom: 10px;\n}\n.m-0 {\n    margin: 0px;\n}\n\n.align-items-center {\n    align-items: center;\n\n    img{\n        background-color: #206ead;\n        padding: 1em;\n        width: 80%;\n    }\n}\n\n.login-header {\n    font-size: 20px;\n    font-weight: bold;\n}\n\n.checkbox-label {\n    display: inline-flex;\n}\n.checkbox-square {\n    aspect-ratio: 1;\n}\n.m-r-5 {\n    margin: 0px 5px 0px 0px !important;\n}\n.login-button {\n    width: 100%;\n    text-transform: capitalize;\n}\n\n.cursor-pointer {\n    cursor: pointer;\n}\n\n.loading-screen {\n    min-height: 280px;\n    font-size: 60px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
